import type { Ref } from 'vue';
import { Tracer } from '~/lib/Tracing';
import { isValidWebAppLocale } from '~/utils/guards/isValidWebAppLocale';
import { type RelevantStoreConfig } from '~/plugins/10.shop';

export function useStoreConfig(
  locale: string | undefined,
  shopStore: string | undefined
): Promise<Ref<RelevantStoreConfig | null>> {
  const tracer = new Tracer('composables');

  return tracer.withSpan(
    'useStoreConfig',
    {
      'parameter.locale': locale
    },
    async () => {
      if (!shopStore || !locale || !isValidWebAppLocale(locale)) {
        return ref(null);
      }

      const { data, error } = await useFetch<RelevantStoreConfig>(
        '/api/magento/storeConfig',
        {
          ...DEFAULT_FETCH_OPTIONS,
          query: { locale, store: shopStore }
        }
      );

      if (error.value) {
        throw error.value;
      }

      if (!data.value) {
        throw createError('failed to load storeConfig (useStoreConfig)');
      }

      return data;
    }
  );
}
